// chan-fe config — runtime constants and endpoint wiring.
//
// The app hits the live Mitra instance over OAuth-protected endpoints. The
// Caddyfile reverse-proxies /api/* and /oauth/* to the instance, so requests
// to the signed-in instance are same-origin; other instances (cross-instance
// sign-in) are reached directly at their own origin.

// OAuth config — app registers dynamically via POST /api/v1/apps
// (standard Mastodon API). No hardcoded clientId or instance.
// defaultInstance: when signed into this instance, API calls use same-origin
// (go through the Caddy reverse proxy, no CORS overhead). It defaults to the
// hostname serving chan-fe, which is right for the recommended deployment.
// Set it explicitly when developing on localhost or hosting the frontend on a
// different hostname from the reverse-proxied fediverse instance.
const BUILD_DEFAULT_INSTANCE = typeof __CHAN_FE_DEFAULT_INSTANCE__ !== "undefined"
  ? __CHAN_FE_DEFAULT_INSTANCE__
  : null;

export const OAUTH_CONFIG = {
  scopes:          "read write",
  redirectUri:     "urn:ietf:wg:oauth:2.0:oob",
  defaultInstance: BUILD_DEFAULT_INSTANCE || globalThis.location?.hostname || "example.com",
};

export const PER_PAGE_DEFAULT = 25;

// How many statuses each timeline fetch asks for. Must match the `limit=`
// in LIVE_BOARD_PATHS below — the catalog uses it to decide whether a full
// page came back (so there may be more to load) for infinite scroll.
export const TIMELINE_PAGE_SIZE = 40;

export const BOARDS = {
  home:  { title: "/home/",  desc: "Posts from accounts you follow." },
  twkn:  { title: "/twkn/",  desc: "Federated public timeline across the fediverse." },
  local: { title: "/local/", desc: "Public posts from this instance only." },
  likes: { title: "/likes/", desc: "Posts you've liked." },
  bkmks: { title: "/bkmks/", desc: "Posts you've bookmarked." },
  dm:    { title: "/dm/",    desc: "Your direct message conversations." },
};

export const SORT_MODES = {
  bump:    { label: "Bump order" },
  new:     { label: "Newest" },
  old:     { label: "Oldest" },
  replies: { label: "Reply count" },
  reacts:  { label: "React count" },
};

export const AUTH_STORAGE_KEY = "chan_fe_auth";
export const APP_STORAGE_KEY = "chan_fe_apps";

// Board → API path mapping. In live mode, hitting the authed endpoints
// (home, likes) requires a valid bearer token. /twkn/ is the federated
// public timeline (matches Mitra-web's /federated), /local/ is local-only
// (matches Mitra-web's /local).
export const LIVE_BOARD_PATHS = {
  home:  "/api/v1/timelines/home?limit=40",
  twkn:  "/api/v1/timelines/public?limit=40",                  // federated
  local: "/api/v1/timelines/public?local=true&limit=40",       // local-only
  likes: "/api/v1/favourites?limit=40",
  bkmks: "/api/v1/bookmarks?limit=40",
  // /dm/ returns Conversation entities, not statuses — see loadTimeline.
  dm:    "/api/v1/conversations?limit=40",
};

// /dm/'s wider scope (the "all messages" toggle): every direct post you sent
// or were mentioned in, including DMs that branch off a public or
// followers-only thread — those have a non-direct conversation root, so
// /api/v1/conversations never lists them. Returns statuses, paged by post id.
export const DM_ALL_MESSAGES_PATH = "/api/v1/timelines/direct?limit=40";
